import { useState, useEffect } from 'react';
import { useWS } from './useWebSocket';
import { getMetrics } from '../services/api';

export function useLiveMetrics() {
  const { metrics: wsMetrics } = useWS();
  const [metrics, setMetrics] = useState(null);
  const [loading, setLoading] = useState(true);

  // Initial fetch via REST
  useEffect(() => {
    getMetrics()
      .then(data => {
        setMetrics(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch metrics:', err);
        setLoading(false);
      });
  }, []);

  // Update from WebSocket
  useEffect(() => {
    if (wsMetrics) {
      setMetrics(wsMetrics);
      setLoading(false);
    }
  }, [wsMetrics]);

  return { metrics, loading };
}
